module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.human.nameShort) + "\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.human && _vm.human.id),
      expression: "human && human.id"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(0, 0)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('div', [_c('b', [_vm._v(_vm._s(_vm.human.nameFull))])]), _vm._v(" "), _c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnflHtml(_vm.human.inn))
    }
  })])]), _vm._v(" "), _c(_vm.createComp(_vm.formatHumanCountersHtml(_vm.human.counters)), {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.human && _vm.human.id),
      expression: "human && human.id"
    }],
    tag: "component"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showExactCompanies
    },
    on: {
      "click": function($event) {
        _vm.showExactCompanies = !_vm.showExactCompanies
      }
    }
  }, [_vm._v("\n                Отчет о найденных компаниях при совпадении ИНН \n                физического лица\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExactCompanies),
      expression: "showExactCompanies"
    }],
    staticClass: "pt-0"
  }, [(_vm.displayCompaniesExact.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayCompaniesExact), function(item) {
    return [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.heads)),
        expression: "isExistActualItem(item.heads)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('head')))]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.holders)),
        expression: "isExistActualItem(item.holders)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('holder')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРН "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n                    "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l((item.heads), function(head) {
      return [_c('div', [_c('b', {
        style: (head.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v(_vm._s(head.position ? head.position : ''))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(head))
        }
      }), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.formatDisqualificationHtml(head.disqualification))
        }
      })])]
    }), _vm._v(" "), _vm._l((item.holders), function(holder) {
      return [_c('div', [_c('b', {
        style: (holder.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })])]
    })], 2)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showLoners
    },
    on: {
      "click": function($event) {
        _vm.showLoners = !_vm.showLoners
      }
    }
  }, [_vm._v("\n                Отчет о ИП при совпадении ИНН \n                физического лица\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoners),
      expression: "showLoners"
    }],
    staticClass: "pt-0"
  }, [(!_vm.loners || _vm.loners.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.loners), function(item) {
    return [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('loner')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРНИП "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnflHtml(item.inn))
      }
    })]), _vm._v(" - \n                  "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    })])]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showNotExactCompanies
    },
    on: {
      "click": function($event) {
        _vm.showNotExactCompanies = !_vm.showNotExactCompanies
      }
    }
  }, [_vm._v("\n                Отчет о найденных компаниях при совпадении: ФИО (без совпадений по ИНН)\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotExactCompanies),
      expression: "showNotExactCompanies"
    }],
    staticClass: "pt-0"
  }, [(_vm.displayCompaniesNotExact.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _c('v-flex', [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" В этот отчет могли попасть иные лица с тождественными ФИО.\n              ")]), _vm._v(" "), _vm._l((_vm.displayCompaniesNotExact), function(item) {
    return [_c('div', [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.heads)),
        expression: "isExistActualItem(item.heads)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('head')))]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.holders)),
        expression: "isExistActualItem(item.holders)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('holder')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРН "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n                    "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l((item.heads), function(head) {
      return [_c('div', [_c('b', {
        style: (head.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v(_vm._s(head.position ? head.position : ''))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(head))
        }
      }), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.formatDisqualificationHtml(head.disqualification))
        }
      })])]
    }), _vm._v(" "), _vm._l((item.holders), function(holder) {
      return [_c('div', [_c('b', {
        style: (holder.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })])]
    })], 2)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-304f78da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/HumanPage.vue
// module id = 1099
// module chunks = 1